module.exports = __webpack_public_path__ + "static/img/mission.962211de.png";